import React from "react";
import { useState } from "react";
import NewsletterPageQuery from "components/pages/newsletter/NewsletterPageQuery";
import ApiUser from "models/data/api/ApiUser";
import NewsletterSignupForm from "components/pages/newsletter/NewsletterSignupForm";
import NewsletterReferralStatus from "components/pages/newsletter/NewsletterReferralStatus";
import SuccessMessage from "components/shared/alerts/SuccessMessage";
import { FooterWithState } from "components/Footer";
import useFirebaseSession from "hooks/useFirebaseSession";
import withApollo from "components/higher-order/withApollo";
import PageContainer from "components/containers/PageContainer";
import { useRecordPageView } from "hooks/analytics/useRecordPageView";
import {
  NewsletterPageContextProvider,
  useNewsletterPageContext,
} from "contexts/new/NewsletterPageContext";
import { useRecordNewsletterSubscribed } from "hooks/analytics/useRecordNewsletterSubscribed";
import { NextSeo } from "next-seo";

function Newsletter() {
  const [signupSuccessMessageShown, setSignupSuccessMessageShown] =
    useState(false);
  const { userIsLoggedIn, sessionInitialized } = useFirebaseSession();

  const pageContext = useNewsletterPageContext();
  const recordNewsletterSubscribed = useRecordNewsletterSubscribed(pageContext);

  function onSignup(email: string, subscriberId: string) {
    recordNewsletterSubscribed(email, "newsletterpage", subscriberId);
    setSignupSuccessMessageShown(true);
  }

  useRecordPageView();
  const description =
    "It’s like your other newsletters, but Browner. Join thousands and get the best curated roundup of global news on South Asia(ns) every Sunday.";
  return (
    <PageContainer>
      <NextSeo
        title="Sign up for our free Sunday newsletter | The Juggernaut"
        twitter={{ cardType: "summary_large_image" }}
        description={description}
        openGraph={{
          title: "Sign up for our free Sunday newsletter",
          type: "website",
          site_name: "The Juggernaut",
          description,
        }}
      />
      <div className="flex flex-col">
        <SuccessMessage
          show={signupSuccessMessageShown}
          text="You are now subscribed to the Juggernaut Weekly!"
          onClickClose={() => setSignupSuccessMessageShown(false)}
        />
        <div className="min-h-screen w-full flex items-center justify-center">
          {sessionInitialized && !userIsLoggedIn && (
            <NewsletterSignupForm
              afterSignup={onSignup}
              loggedIn={false}
              email={""}
            />
          )}
          {sessionInitialized && userIsLoggedIn && (
            <NewsletterPageQuery>
              {({ user }) =>
                ApiUser.isNewsletterSubscriber(user) ? (
                  <NewsletterReferralStatus email={ApiUser.email(user)} />
                ) : (
                  <NewsletterSignupForm
                    loggedIn={true}
                    email={ApiUser.email(user)}
                    afterSignup={onSignup}
                  />
                )
              }
            </NewsletterPageQuery>
          )}
        </div>
        <FooterWithState />
      </div>
    </PageContainer>
  );
}

function NewsletterPage() {
  return (
    <NewsletterPageContextProvider>
      <Newsletter />
    </NewsletterPageContextProvider>
  );
}

export default withApollo(NewsletterPage);
